import React, { useContext } from 'react';
import WorldPinImage from '@shared/assets/images/v2/world-pin.svg';
import { View } from '@shared/components/View';
import { MBBottomSheet } from '@shared/components/bottomSheet';
import { MBButton } from '@shared/components/button';
import { MBImage } from '@shared/components/image';
import { MBTextBody1 } from '@shared/components/typography';
import { ColorThemeContext, grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';

interface Props {
  anchorName: string;
  onClose(): void;
  onPress(): void;
}

export function PromptBottomSheetContent({ anchorName, onPress, onClose }: Props) {
  const colors = useContext(ColorThemeContext);

  return (
    <MBBottomSheet
      anchorName={anchorName}
      title={i18n('card.blocks.geolocationInput.prompt.title')}
      onClose={onClose}
    >
      <View padding={4} style={{ width: 320, alignSelf: 'center' }}>
        <MBTextBody1 align="center" color={colors.foregroundActive}>
          {i18n('card.blocks.geolocationInput.prompt.description')}
        </MBTextBody1>
        <View paddingTop={4} />
        <MBImage
          source={WorldPinImage}
          style={{ height: grid(12), width: '100%' }}
          resizeMode="contain"
        />
        <View paddingTop={4} />
        <MBButton title={i18n('card.blocks.geolocationInput.prompt.cta')} onPress={onPress} />
      </View>
    </MBBottomSheet>
  );
}
